<script setup lang="ts">
import useSafePassword from '@/composables/useSafePassword'
import { storeToRefs } from 'pinia'
import { ref, computed, watch, type Ref } from 'vue'

const safePassword = useSafePassword()
const { score, specialCharacters, hasNumber, hasLowercase, hasUppercase, hasSpecialCharacter, hasEnoughCharacters } = storeToRefs(safePassword)

export interface Props {
  formRef: Ref | undefined
}

const props = defineProps<Props>()

const onInput = (value: string) => {
  safePassword.updatePassword(value)
  props.formRef.setFieldValue('score', score)
}

</script>
<template>
  <div>
    <storm-ui-form-group>
      <div class="col-span-12">
        <storm-ui-password-input
          id="new-password"
          autocomplete="new-password"
          rules="required|min:12|safe-password:14:score"
          name="new-password"
          type="password"
          label="Neues Kennwort"
          @input="onInput"
        />
        <storm-ui-input
          name="score"
          type="hidden"
        />
      </div>
      <div class="col-span-12">
        <storm-ui-input
          id="confirm-password"
          autocomplete="new-password"
          rules="required|confirmed:@new-password"
          name="confirm-password"
          type="password"
          label="Wiederholung"
        />
      </div>
    </storm-ui-form-group>
    <storm-ui-form-group>
      <div class="col-span-24 space-y-2">
        <h1 class="text-base text-black font-medium">
          Das Kennwort muss enthalten:
        </h1>
        <storm-ui-checker :checked="hasEnoughCharacters">
          mindestens acht Zeichen
        </storm-ui-checker>
        <storm-ui-checker :checked="hasNumber">
          enthält mindestens eine Zahl
        </storm-ui-checker>
        <storm-ui-checker :checked="hasLowercase">
          enthält mindestens einen Kleinbuchstaben
        </storm-ui-checker>
        <storm-ui-checker :checked="hasUppercase">
          enthält mindestens einen Großbuchstaben
        </storm-ui-checker>
        <storm-ui-checker :checked="hasSpecialCharacter">
          enthält mindestens ein Sonderzeichen
          (<span
            v-for="(character, index) in specialCharacters"
            :key="index"
            class="not-last:pr-0.5 font-medium"
          >
            <span>{{ character }}</span>
          </span>)
        </storm-ui-checker>
      </div>
    </storm-ui-form-group>
  </div>
</template>
